import type { PackingListRow } from "@RequestFormV2/sections/PackingList/types";
import {
  formatUnitCellLines,
  type ReviewPackingListLabelContext,
} from "@RequestFormV2/components/ReviewPage/sections/ReviewPackingList/reviewPackingListFormatters";

type ReviewPackingListUnitCellProps = {
  row: PackingListRow;
  labelContext: ReviewPackingListLabelContext;
};

export default function ReviewPackingListUnitCell({ row, labelContext }: ReviewPackingListUnitCellProps) {
  const { label, dimensions, weight } = formatUnitCellLines(row, labelContext);

  return (
    <div className="rfv2-review-packing-list__unit-cell">
      <span className="rfv2-review-packing-list__unit-cell-label">{label}</span>
      {dimensions && <span className="rfv2-review-packing-list__unit-cell-line">{dimensions}</span>}
      {weight && (
        <span className="rfv2-review-packing-list__unit-cell-line">
          {weight.value}
          <span className="rfv2-review-packing-list__unit-cell-suffix">{weight.suffix}</span>
        </span>
      )}
    </div>
  );
}
